import { OnInit } from '@angular/core';
var PxdataComponent = /** @class */ (function () {
    function PxdataComponent(userService, papa, HttpClient) {
        this.userService = userService;
        this.papa = papa;
        this.HttpClient = HttpClient;
        this.accept = '*';
        this.pxDataArray = [];
        this.isLoading = true;
        this.files = [];
        this.processedFiles = 0;
        this.warningMessages = [];
        this.hasBaseDropZoneOver = false;
    }
    PxdataComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.successMessage = "";
        this.userService.getUsers().subscribe(function (users) {
            _this.users = users;
            _this.isLoading = false;
        }, function (err) {
            _this.isLoading = false;
            alert('error');
            console.log('error to get users: ', err);
        });
    };
    PxdataComponent.prototype.getDate = function () {
        return new Date();
    };
    PxdataComponent.prototype.cancel = function () {
        this.progress = 0;
        if (this.httpEmitter) {
            console.log('cancelled');
            this.httpEmitter.unsubscribe();
        }
    };
    PxdataComponent.prototype.uploadFiles = function (files) {
        var _this = this;
        if (files && files.length > 0) {
            this.isLoading = true;
            this.warningMessages = [];
            var _loop_1 = function (i) {
                var reader = new FileReader();
                reader.readAsText(files[i]);
                reader.onload = function (data) {
                    _this.papa.parse(reader.result.toString(), {
                        header: true,
                        complete: function (parsedData) {
                            var selectedUser;
                            _this.isLoading = true;
                            var found = false;
                            for (var j = 0; j < _this.users.length; j++) {
                                if (files[i].name.split(' ')[0] === _this.users[j].linkedInProfileId || files[i].name.split(' ')[0] === _this.users[j].memberId) {
                                    selectedUser = _this.users[j];
                                    found = true;
                                }
                            }
                            if (!found) {
                                _this.warningMessages.push({ filename: files[i].name, message: "This file cannot be imported. Please check the LinkedIn ID in the file name is correct." });
                            }
                            else if (!files[i].name.includes(' PX ')) {
                                _this.warningMessages.push({ filename: files[i].name, message: "This file cannot be imported. Please make sure the filename contains PX with spaces on both sides." });
                            }
                            else {
                                for (var k = 0; k < parsedData.data.length; k++) {
                                    if (!parsedData.data[k].id || !parsedData.data[k].public_id || !parsedData.data[k].member_id) {
                                        _this.warningMessages.push({ filename: files[i].name, message: "This file cannot be imported. Please confirm the file was exported from LH2." });
                                        break;
                                    }
                                }
                            }
                            if (_this.warningMessages.length === 0) {
                                _this.userService.updatePXData(parsedData.data, selectedUser._id).subscribe(function (_id) {
                                    _this.processedFiles++;
                                    console.log("processed file #" + _this.processedFiles);
                                    if (_this.processedFiles === files.length) {
                                        _this.isLoading = false;
                                        _this.pxDataArray = null;
                                        _this.files = [];
                                        _this.warningMessages = [];
                                        _this.processedFiles = 0;
                                    }
                                }, function (err) {
                                    _this.warningMessages = [];
                                    _this.isLoading = false;
                                    alert('error');
                                    console.log('error to update pxdata: ', err);
                                });
                            }
                            else {
                                _this.isLoading = false;
                            }
                        }
                    });
                };
            };
            for (var i = 0; i < files.length; i++) {
                _loop_1(i);
            }
            this.files = [];
        }
        else {
            alert('Please select data file.');
        }
    };
    return PxdataComponent;
}());
export { PxdataComponent };
